import CreateBorrowerContent from "../../content/borrower/createBorrower";
import { Layout } from "../../layout/page";

export function CreateBorrower() {
  return (
    <Layout>
      <CreateBorrowerContent />
    </Layout>
  );
}
